import { ProductResult } from "@encoway/c-services-js-client"

import { IVisualizationServer } from "./visualizationService.types"

/**
 * Triggers the download of the given blob object in the browser.
 * @param {Blob} blob The blob object to download.
 * @param {String} filename The name of the file.
 */
export function download(blob: Blob, filename: string) {
    const downloadLink = document.createElement("a")
    downloadLink.href = URL.createObjectURL(blob)
    downloadLink.download = filename
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
}

/**
 * Returns the product information for the provided product id.
 * @param {IVisualizationServer} visualization The visualization API.
 * @param {String} productId The ID of the product to provide information of.
 * @return {Promise<ProductResult | null>} The product information or null, if the visualization has no "default" server registered.
 */
export async function getProductInfo(
    visualization: IVisualizationServer,
    productId: string
): Promise<ProductResult | null> {
    const server = visualization.cloud?.server("default")
    if (!server) {
        return null
    }

    return await server.catserv.product(productId)
}
